import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      /* { path: '', component: () => import('pages/IndexPage.vue') } */
      {
        path: '',
        component: () => import('pages/workflow/ShowWorkflows.vue'),
      },
    ],
  },
  {
    path: '/login',
    component: () => import('pages/auth/LoginPage.vue'),
  },
  {
    path: '/app',
    component: () => import('layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '/dashboard', component: () => import('pages/IndexPage.vue') },
      { path: '/components/test', component: () => import('pages/ComponentsTest.vue') },
      { path: '/nodes', name: 'nodes', component: () => import('pages/nodes/Index.vue') },
      // { path: '/nodes', name: 'nodes', component: () => import('pages/workflow/Index.vue') },
      {
        path: '/overview',
        name: 'overview',
        component: () => import('pages/overview/OverviewPage.vue'),
      },
      {
        path: '/workflows',
        name: 'showWorkflows',
        component: () => import('pages/workflow/ShowWorkflows.vue'),
      },
      {
        path: '/workflow-instances',
        name: 'workflowInstances',
        component: () => import('pages/workflow-instances/WorkflowInstances.vue'),
      },
      {
        path: '/active-tasks',
        name: 'activeTasks',
        component: () => import('pages/active-tasks/ActiveTasks.vue'),
      },
      {
        path: '/my-requests',
        name: 'myRequests',
        component: () => import('pages/my-requests/MyRequests.vue'),
      },
      {
        path: '/new-request',
        name: 'newRequest',
        component: () => import('pages/new-request/NewRequest.vue'),
      },
      // { path: '/dashboard', component: () => import('pages/DashboardPage.vue') },
      // { path: '/profile', component: () => import('pages/ProfilePage.vue') },
      // { path: '/documentos', component: () => import('pages/DocumentosPage.vue') },
      // { path: '/usuarios', component: () => import('pages/UsuariosPage.vue') },
      // { path: '/configuracion', component: () => import('pages/ConfiguracionPage.vue') },
      /* {
        path: '/gestion-documentos',
        component: () => import('pages/gestion-documentos/GestionDocumentosPage.vue'),
      }, */
    ],
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
